import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../../tailwind.config.js';

// Resolve Tailwind config
const fullConfig = resolveConfig(tailwindConfig);

export const CAROUSEL_DEFAULT_ARGS = ({
    modules,
    $prevButton,
    $nextButton,
    updateCallback,
    isPrefersReducedMotion = false
}) => {
    return {
        modules: modules,
        speed: isPrefersReducedMotion ? 0 : 400,
        effect: isPrefersReducedMotion ? 'fade' : 'slide',
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: fullConfig.theme.spacing['gutterMobile'],
        navigation: {
            prevEl: $prevButton,
            nextEl: $nextButton
        },
        breakpoints: {
            700: {
                spaceBetween: fullConfig.theme.spacing['gutter']
            }
        },
        on: {
            init: updateCallback ? updateCallback : () => {},
            breakpoint: updateCallback ? updateCallback : () => {},
            destroy: updateCallback ? updateCallback : () => {}
        }
    };
};

export const CAROUSEL_LISTING_GALLERY_ARGS = ({
    modules,
    updateCallback,
    isPrefersReducedMotion = false
}) => {
    return {
        modules: modules,
        speed: isPrefersReducedMotion ? 0 : 400,
        effect: isPrefersReducedMotion ? 'fade' : 'slide',
        slidesPerView: 1.1,
        spaceBetween: fullConfig.theme.spacing['gutterMobile'],
        on: {
            init: updateCallback ? updateCallback : () => {},
            breakpoint: updateCallback ? updateCallback : () => {},
            destroy: updateCallback ? updateCallback : () => {}
        }
    };
};

export const CAROUSEL_HIGHLIGHTS_ARGS = ({
    modules,
    $prevButton,
    $nextButton,
    updateCallback,
    isPrefersReducedMotion = false
}) => {
    return {
        modules: modules,
        speed: isPrefersReducedMotion ? 0 : 400,
        effect: isPrefersReducedMotion ? 'fade' : 'slide',
        slidesPerView: 'auto',
        spaceBetween: fullConfig.theme.spacing['gutter'],
        navigation: {
            prevEl: $prevButton,
            nextEl: $nextButton
        },
        on: {
            init: updateCallback ? updateCallback : () => {},
            breakpoint: updateCallback ? updateCallback : () => {},
            destroy: updateCallback ? updateCallback : () => {}
        }
    };
};
